import { apiFetch } from "@/lib/api";

import type { HubContactSelection } from "@/lib/hubContactsApi";

export const TRANSFER_SHIPPED_NOTIFICATION_SETTINGS_QUERY_KEY = [
  "manufacturing",
  "transfer-shipped-notifications",
  "settings",
] as const;

export type TransferShippedNotificationRecipient = HubContactSelection;

export interface TransferShippedNotificationLocationRecipients {
  destinationLocationId: number;
  notifyRecipients: TransferShippedNotificationRecipient[];
}

export interface TransferShippedNotificationSettings {
  recipientsByDestination: TransferShippedNotificationLocationRecipients[];
  updatedAt: string | null;
  locations: { destinationLocationId: number; displayName: string; abbreviation: string }[];
}

export async function fetchTransferShippedNotificationSettings(): Promise<TransferShippedNotificationSettings> {
  return apiFetch<TransferShippedNotificationSettings>(
    "/api/manufacturing/transfer-shipped-notifications/settings",
  );
}

export async function patchTransferShippedNotificationSettings(
  recipientsByDestination: Array<{
    destinationLocationId: number;
    notifyRecipients: Array<{ hubContactId: number }>;
  }>,
): Promise<TransferShippedNotificationSettings> {
  return apiFetch<TransferShippedNotificationSettings>(
    "/api/manufacturing/transfer-shipped-notifications/settings",
    {
      method: "PATCH",
      body: { recipientsByDestination },
    },
  );
}
